import React, { useRef } from 'react';
import { placeholder, responsive } from '@cloudinary/react';
import { useCloudinary } from '../../../../hooks/Cloudinary/useCloudinary';
import { usePrefersReducedMotion } from '../../../../hooks/usePreferReducedMotion';
import * as S from './MemoizedImageOrVideo.styles';

type MemoizedImageOrVideoProps = {
  imageId?: string;
  videoId?: string;
  altText?: string;
};

const MemoizedImageOrVideo = React.memo(({ imageId, videoId, altText }: MemoizedImageOrVideoProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const { getResponsiveVideo } = useCloudinary();
  const prefersReducedMotion = usePrefersReducedMotion();
  const cldVideo = getResponsiveVideo(videoId);

  return (
    <S.ImageContainer>
      <S.StyledResponsiveImage imageId={imageId} altText={altText} />
      {!imageId && cldVideo && (
        <S.StyledVideo
          innerRef={videoRef}
          cldVid={cldVideo}
          plugins={[responsive({ steps: 50 }), placeholder({ mode: 'blur' })]}
          controls={false}
          autoPlay={!prefersReducedMotion}
          muted
          playsInline
          loop
        />
      )}
    </S.ImageContainer>
  );
});

export default MemoizedImageOrVideo;
